<template>
  <div>

    <div class="cert-header d-flex py-5">
      <div class="col-9 mx-auto">
        <div class="cert-title cert-large">Subscribe</div>
      </div>
    </div>
    <div class="col-4 mx-auto mt-5 cert-page-content py-5 px-5">
      <div class="cert-text" style="font-weight: 600;font-size: 0.8rem">
        Rw-CERT will send cybersecurity alerts and advisories directly to your email.
      </div>
      <div class="mt-4">
        <div class="">
          <label>Email address<font color="red">*</font></label>
          <argon-input type="email" placeholder="Your email address" name="email" size="lg" class="mt-0"
                       v-model="email"/>
        </div>

        <div class="text-center">
          <argon-button
              class="mt-4"
              variant="gradient"
              fullWidth
              color="primary"
              size="lg">Subscribe
          </argon-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ArgonInput from "@/components/ArgonInput";
import ArgonButton from "@/components/ArgonButton";
import api from "@/api";
import validators from "@/assets/helper/validators";

export default {
  name: "Subscribe",
  components: {
    ArgonInput,
    ArgonButton
  },
  data() {
    return {
      email: '',
      validation: {
        email: '',
        status: false,
        message:"",
      }
    }
  },
  methods: {
    submit(email) {
      if (validators.validateEmailAddress(email)) {
        this.validation.message="";
        api.post(`${process.env.VUE_APP_BASE_URL}subscription?email=${email}`);
      } else {
        this.validation.message="<font color='red'>Invalid email address</font>";
      }
    }
  }
  };
</script>